import { render, staticRenderFns } from "./SplitHeading.vue?vue&type=template&id=3e554d70&"
import script from "./SplitHeading.vue?vue&type=script&lang=js&"
export * from "./SplitHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports